import TextBox from "devextreme-react/text-box";
import React, {useEffect} from "react";
import {NumberBox} from "devextreme-react/number-box";
import Box, {Item,} from 'devextreme-react/box';
import {Backsplash} from "../../types/Backsplash";
import {useCountertops} from "../../contexts/countertopsContext";
import Validator from "devextreme-react/validator";
import {CustomRule} from "devextreme-react/form";

export function BacksplashLineControl({
    shapeId,
    materialName,
    colorName,
    backsplash
}: {
    shapeId: number,
    materialName: string,
    colorName: string,
    backsplash: Backsplash
}) {
    const context = useCountertops();

    const [sColorName, setColorName] = React.useState(colorName);
    const [sMaterialName, setMaterialName] = React.useState(materialName);

    useEffect(() => {
        setColorName(colorName);
        setMaterialName(materialName);
    }, [colorName, materialName])

    return (
        <div>
            <Box
                direction="row"
                width="100%">
                <Item ratio={6}>
                    <Box>
                        <Item ratio={2}>
                            <div style={{ marginRight: '20px', textAlign: 'right' }}>
                                <label>
                                    &nbsp;
                                    <TextBox mode='text' stylingMode='outlined'
                                        inputAttr={{ "style": "text-align:right" }} text={backsplash.name}></TextBox>
                                </label>
                            </div>
                        </Item>
                        <Item ratio={2}>
                            <label style={{ marginRight: "20px" }}>
                                Material*
                                <TextBox mode='text' stylingMode='outlined'
                                    value={sMaterialName}></TextBox>
                            </label>
                        </Item>
                        <Item ratio={3}>
                            <label style={{ marginRight: "20px" }}>
                                Color*
                                <TextBox mode='text' stylingMode='outlined'
                                    value={sColorName}></TextBox>
                            </label>
                        </Item>
                    </Box>
                </Item>
                <Item ratio={4}>
                    <Box crossAlign='center'>
                        <Item baseSize={70}>
                            <label>
                                Length(in)
                                <NumberBox
                                    stylingMode='outlined'
                                    inputAttr={{ "style": "text-align:center" }}
                                    value={backsplash.length}
                                    valueChangeEvent='blur'
                                    onValueChanged={(e) => {
                                        if (e.event) {
                                            let value: number | undefined = undefined;
                                            if (e.value !== null && e.value !== undefined) {
                                                value = +(e.value).toFixed(2);
                                            }

                                            let total: number | undefined = undefined;
                                            if (value !== undefined && backsplash.height !== undefined) {
                                                total = +(((backsplash.height ?? 0) * e.value) / 144).toFixed(2);
                                            }

                                            context.updateBacksplashDimensions(shapeId, backsplash.id, value, backsplash.height, total)
                                        }
                                    }}
                                />
                            </label>
                        </Item>
                        <Item baseSize={30}>
                            <label style={{ marginRight: "10px", marginLeft: "10px" }}>
                                &nbsp;
                            </label>
                            <div style={{
                                justifyContent: "center",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                textAlign: "center"
                            }}>
                                <i className="dx-icon-close" style={{ display: "block" }}></i>
                            </div>
                        </Item>
                        <Item baseSize={70}>
                            <label>
                                Height(in)
                                <NumberBox
                                    stylingMode='outlined'
                                    inputAttr={{ "style": "text-align:center" }}
                                    value={backsplash.height}
                                    valueChangeEvent='blur'
                                    onValueChanged={(e) => {
                                        if (e.event) {
                                            let value: number | undefined = undefined;
                                            if (e.value !== null && e.value !== undefined) {
                                                value = +(e.value).toFixed(2);
                                            }

                                            let total: number | undefined = undefined;
                                            if (value !== undefined && backsplash.length !== undefined) {
                                                total = +(((backsplash.length ?? 0) * e.value) / 144).toFixed(2);
                                            }

                                            context.updateBacksplashDimensions(shapeId, backsplash.id, backsplash.length, value, total);
                                        }
                                    }}
                                />
                            </label>
                        </Item>
                        <Item baseSize={30}>
                            <label style={{ marginRight: "10px", marginLeft: "10px" }}>
                                &nbsp;
                            </label>
                            <div style={{
                                justifyContent: "center",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                textAlign: "center"
                            }}>
                                <i className="dx-icon-equal" style={{ display: "block" }}></i>
                            </div>
                        </Item>
                        <Item baseSize={70}>
                            <label>
                                Total(sq. ft.)
                                <NumberBox
                                    stylingMode='outlined'
                                    inputAttr={{ "style": "text-align:center" }}
                                    value={backsplash.total}
                                    valueChangeEvent='blur'
                                    onValueChanged={(e) => {
                                        if (e.event) {
                                            let value: number | undefined = undefined;
                                            if (e.value !== null && e.value !== undefined) {
                                                value = +(e.value).toFixed(2);
                                            }
                                            context.updateBacksplashDimensions(shapeId, backsplash.id, backsplash.length, backsplash.height, value)
                                        }
                                    }}
                                >
                                    <Validator>
                                        <CustomRule message={"Quantity must be set and greater than 0"}
                                            validationCallback={context.qtyValidation}></CustomRule>
                                    </Validator>
                                </NumberBox>
                            </label>
                        </Item>
                        <Item baseSize={70}></Item>
                        <Item>
                            <label style={{ marginRight: "10px", marginLeft: "10px" }}>
                                &nbsp;
                            </label>
                            <a style={{ color: 'red', marginLeft: '20px' }}
                                onClick={() => context.removeBacksplash(shapeId, backsplash.id)}>Remove</a>
                        </Item>
                    </Box>
                </Item>
            </Box>
        </div>
    );
}
